export default __webpack_public_path__ + "assets/images/NoMaskExtrema-6a5e50321f0e8a62c2d6439fe17e4e30.png";